import React, { useState, useEffect } from 'react';
import { ZONE_TYPES, DEFAULT_ZONE_TYPE } from './zoneUtils';

function ZoneEditor({ zone, index, open, onClose, onSave }) {
	const [values, setValues] = useState({ name: '', description: '', type: DEFAULT_ZONE_TYPE });

	useEffect(() => {
		if (zone) {
			setValues({
				name: zone.name || '',
				description: zone.description || '',
				type: zone.type || DEFAULT_ZONE_TYPE,
			});
		}
	}, [zone]);

	if (!open) return null;

	return (
		<div className="fixed inset-0 flex items-center justify-center bg-black/40 z-[60] p-4">
			<div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-sm">
				<div className="p-5">
					<h4 className="font-semibold mb-3 text-sm">
						{zone?.isNew ? 'Add Zone' : `Edit Zone ${(index ?? 0) + 1}`}
					</h4>
					<div className="space-y-3">
						<div>
							<label className="text-xs text-gray-500 dark:text-gray-400">Name</label>
							<input
								className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-gray-700 focus:border-[#880e4f] rounded-xl px-4 py-2 w-full text-sm mt-0.5"
								value={values.name}
								onChange={(e) => setValues({ ...values, name: e.target.value })}
								placeholder="Zone name"
							/>
						</div>
						<div>
							<label className="text-xs text-gray-500 dark:text-gray-400">Description</label>
							<textarea
								className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-gray-700 focus:border-[#880e4f] rounded-xl px-4 py-2 w-full text-sm mt-0.5 resize-none"
								rows={2}
								value={values.description}
								onChange={(e) => setValues({ ...values, description: e.target.value })}
								placeholder="Optional notes about this zone"
							/>
						</div>
						<div>
							<label className="text-xs text-gray-500 dark:text-gray-400">Type</label>
							<select
								className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-gray-700 focus:border-[#880e4f] rounded-xl px-4 py-2 w-full text-sm mt-0.5"
								value={values.type || DEFAULT_ZONE_TYPE}
								onChange={(e) => setValues({ ...values, type: e.target.value })}
							>
								{ZONE_TYPES.map((t) => (
									<option key={t} value={t}>{t.toUpperCase()}</option>
								))}
							</select>
						</div>
					</div>
				</div>
				<div className="px-5 py-3 border-t dark:border-gray-700 flex gap-2 justify-end bg-gray-50 dark:bg-gray-800 rounded-b-2xl">
					<button
						onClick={onClose}
						className="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
					>
						Cancel
					</button>
					<button
						onClick={() => { onSave(values); onClose(); }}
						className="px-3 py-1.5 text-sm bg-[#880e4f] text-white rounded-lg hover:bg-[#6b0b3f]"
					>
						Save
					</button>
				</div>
			</div>
		</div>
	);
}

export default ZoneEditor;
